import React from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { Map } from 'immutable'
import { airportNameLocByIata } from '../airport/airportUtils'
import moment from 'moment'

const OffersSummary = ({offers, airportByIata = Map()})=>
{
  return <div>
      <section className="book-section">
        <h2>Offer{offers.count() > 1 ? 's' : ''} Summary</h2>
        <ul>
          {
            offers.map((offer, i)=>{
              return offer.get("serviceDetail").map( (serviceDetail) => {
                const fromUri = serviceDetail.get('from','')
                const fromIata = fromUri.substring(fromUri.length - 3)
                const toUri = serviceDetail.get('to','')
                const toIata = toUri.substring(toUri.length - 3)
                const mCommence = moment( serviceDetail.get('commence') )

                return <li key={i}><span>{mCommence.format("dddd, DD MMMM YYYY")}</span> - <b>{airportNameLocByIata(fromIata, airportByIata)}</b> to <b>{airportNameLocByIata(toIata, airportByIata)}</b></li>
              } )
            })
          }
        </ul>
      </section>
    </div>
}


OffersSummary.propTypes = {
    // List<OfferAsMap>
    offers : ImmutablePropTypes.listOf( ImmutablePropTypes.map ).isRequired,
    // Map<IataCode,AirportAsMap>
    airportByIata : ImmutablePropTypes.map.isRequired
}
export default OffersSummary



// WEBPACK FOOTER //
// ./src/ndc/booking/OffersSummary.js